"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ModuleRegistryFactory_1 = tslib_1.__importDefault(require("./ModuleRegistryFactory"));
class DefaultModule {
    constructor(moduleName) {
        this.headerBoxes = [];
        this.dashboardButtons = [];
        this.tabbedPanels = [];
        this.headerBars = [];
        this.moduleName = moduleName;
        if (document.currentScript instanceof HTMLScriptElement) {
            this.moduleScriptName = document.currentScript.src;
        }
    }
    getTabbedPanels() {
        return this.tabbedPanels;
    }
    getHeaderBoxes() {
        return this.headerBoxes;
    }
    getDashboardButtons() {
        return this.dashboardButtons;
    }
    getHeaderBars() {
        return this.headerBars;
    }
    canSetPatient(_) {
        return undefined;
    }
    setPatient(patient, _) {
        this.moduleContext.setPatient(patient);
        return true;
    }
    refreshPatient(_) {
        // Intentionally left empty
    }
    applicationContextIdChanged(applicationContextId) {
        for (const tab of this.getTabbedPanels()) {
            tab.applicationContextIdChanged(applicationContextId);
        }
        for (const headerBox of this.getHeaderBoxes()) {
            headerBox.applicationContextIdChanged(applicationContextId);
        }
        // Return true to tell boot that informing tabs and header boxes has already been taken care of
        return true;
    }
    getAudiences() {
        return [];
    }
    register() {
        ModuleRegistryFactory_1.default.getInstance().registerModule(this.moduleName, this);
    }
    deregister() {
        ModuleRegistryFactory_1.default.getInstance().deregisterModule(this.moduleName);
    }
    getModuleContext() {
        return this.moduleContext;
    }
    setModuleContext(moduleContext) {
        this.moduleContext = moduleContext;
        // StamdataService.init(moduleContext);
    }
    addTabbedPanel(tabbedPanel) {
        this.tabbedPanels[this.tabbedPanels.length] = tabbedPanel;
    }
    addHeaderBox(headerBox) {
        this.headerBoxes[this.headerBoxes.length] = headerBox;
    }
    addDashboardButton(dashboardButton) {
        this.dashboardButtons.push(dashboardButton);
    }
    addHeaderBar(headerBar) {
        this.headerBars.push(headerBar);
    }
    getName() {
        return this.moduleName;
    }
    getScriptName() {
        return this.moduleScriptName;
    }
    getVersion() {
        return undefined;
    }
    getVersionInfo() {
        return "";
    }
    isEmbeddedModule() {
        return !ModuleRegistryFactory_1.default.isInSubModule();
    }
    loadStylesheetFromParentApp(_) {
        window.alert("NYI: StyleSheetUtil.addStyleSheet");
        // let parentUrl = ModuleRegistryFactory.getParentUrl();
        // let parentBaseUrl = parentUrl.substring(0, parentUrl.lastIndexOf("/"));
        // let stylesheetUrl = parentBaseUrl + "/styles/" + stylesheet;
        // StyleSheetUtil.addStyleSheet(stylesheetUrl);
    }
    setHistoryToken(historyToken) {
        this.moduleContext.setHistoryToken(historyToken);
    }
    getRemoteController() {
        throw new Error("Module " + this.getName() + " is not remote controllable");
    }
    getModuleConfigMetadata() {
        return undefined;
    }
    supportsProcuration() {
        return false;
    }
    setActive(_) {
        //
    }
}
exports.default = DefaultModule;
//# sourceMappingURL=DefaultModule.js.map